<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarAudit",
	data: () => ({
		menuItems: [
			{ title: "Auditor view", link: "/audit/auditor" },
			{ title: "Submitter view", link: "/audit/submitter" },
			{ title: "Audit templates", link: "/audit/templates" },
		],
		sidebar: false
	})
}
</script>
